import qetaPlugin from '@drodil/backstage-plugin-qeta';
import { SearchFilterResultTypeBlueprint } from '@backstage/plugin-search-react/alpha';
import { RiQuestionAnswerFill } from '@remixicon/react';
import {
  createFrontendModule,
  ExtensionDefinition,
} from '@backstage/frontend-plugin-api';

/** Adds "BackOverflow" as a selectable category in the global search filter. */
export const qetaSearchFilterType: ExtensionDefinition =
  SearchFilterResultTypeBlueprint.make({
    name: 'qeta',
    params: {
      value: 'qeta',
      name: 'BackOverflow',
      icon: <RiQuestionAnswerFill />,
    },
  });

/** Replaces the default Qeta page with the internal BackOverflow branding. */
const qetaPageOverride: ExtensionDefinition = qetaPlugin
  .getExtension('page:qeta')
  .override({
    params: {
      title: 'BackOverflow',
    },
  });

/** Bundles all Qeta customisations into a single frontend module. */
export const qetaPluginOverride = createFrontendModule({
  pluginId: 'qeta',
  extensions: [qetaPageOverride, qetaSearchFilterType],
});
